// extracted by mini-css-extract-plugin
export var header = "header-module--header--3p3Mo";
export var logo = "header-module--logo--2iZIR";
export var userProfile = "header-module--user-profile--1dWrz";
export var user = "header-module--user--33IH7";
export var image = "header-module--image--2EdDt";
export var name = "header-module--name--95gSs";
export var navigation = "header-module--navigation--1HWvP";